// AmbientDimmer
// Features:
// - Smoothly animates ambient light intensity
// - Reacts to global outside light state (dimmed vs full)

import { useEffect } from 'react'
import gsap from 'gsap'

import { useActions, OUTSIDE_LIGHT_STATE } from '../../store/useActions'

const DIM_FACTOR = 0.15

export default function AmbientDimmer({ lightRef, baseIntensity }) {
    const outsideLightState = useActions((state) => state.outsideLightState)

    useEffect(() => {
        if (!lightRef?.current) return

        const target =
            outsideLightState === OUTSIDE_LIGHT_STATE.dimmed
                ? baseIntensity * DIM_FACTOR
                : baseIntensity

        gsap.to(lightRef.current, {
            intensity: target,
            duration: 1.0,
            ease: 'linear',
            overwrite: 'auto',
        })
    }, [lightRef, baseIntensity, outsideLightState])

    return null
}
